/** Service for Performance observability API — /api/v1/admin/perf/* */

export interface TimingSample {
  ts: number;
  path: string;
  method: string;
  status: number;
  ms: number;
  cache: string;
}

export interface PathAggregate {
  count: number;
  avg_ms: number;
  p50_ms: number;
  p95_ms: number;
  max_ms: number;
}

export interface ProviderHealth {
  status: string;
  detail: string;
  last_call: string | null;
  fetch_ms: number | null;
  exchange: string;
  provider: string;
}

export interface MarketProvidersHealth {
  iress: ProviderHealth;
  eodhd: ProviderHealth;
  checked_at: string;
}

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8001';

function getToken(): string | null {
  return localStorage.getItem('token');
}

async function authFetch<T>(path: string): Promise<T> {
  const token = getToken();
  const res = await fetch(`${API_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) throw new Error(`${path} → HTTP ${res.status}`);
  return res.json();
}

export async function getPerfTimings(limit = 200): Promise<TimingSample[]> {
  return authFetch<TimingSample[]>(`/api/v1/admin/perf/timings?limit=${limit}`);
}

export async function getPerfAggregates(): Promise<Record<string, PathAggregate>> {
  return authFetch<Record<string, PathAggregate>>('/api/v1/admin/perf/aggregates');
}

export async function getMarketProvidersHealth(): Promise<MarketProvidersHealth> {
  return authFetch<MarketProvidersHealth>('/api/v1/health/market-providers');
}
